module.exports = __webpack_public_path__ + "static/img/bg-pt.318a2ad8.png";